'use client'

import { useUAContext } from '@/context/UAContext'
import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'

type LayoutContextType = {
  headerHeight: number
  logoHeight: number
  setLogoHeight: Dispatch<SetStateAction<number>>
  setHeaderHeight: Dispatch<SetStateAction<number>>
}

const LayoutContext = createContext<LayoutContextType | null>(null)

// Matches Tailwind xl breakpoint (1280px)
const HEADER_HEIGHT_XL = 50
const HEADER_HEIGHT_BELOW_XL = 48
const LOGO_HEIGHT = 24

export function LayoutProvider({ children }: PropsWithChildren) {
  const { device, isMobileApp } = useUAContext()

  const initialHeaderHeight = isMobileApp
    ? 0
    : device === 'mobile_browser'
      ? HEADER_HEIGHT_BELOW_XL
      : HEADER_HEIGHT_XL

  const initialLogoHeight = isMobileApp ? 0 : LOGO_HEIGHT

  const [headerHeight, setHeaderHeight] = useState(initialHeaderHeight)
  const [logoHeight, setLogoHeight] = useState(initialLogoHeight)

  return (
    <LayoutContext.Provider
      value={{
        // 🥷🏼 persona app has no header
        headerHeight: isMobileApp ? 0 : headerHeight,
        logoHeight: isMobileApp ? 0 : logoHeight,
        setHeaderHeight,
        setLogoHeight,
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export const useLayoutContext = () => {
  const value = useContext(LayoutContext)

  if (value == null) {
    throw new Error('useLayoutContext cannot be used outside of LayoutProvider')
  }

  return value
}
